import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { CustomDropdown } from '../deps.js';
import AdminModal from '../AdminModal.js';
import AdminBulkPreview from '../AdminBulkPreview.js';

const BulkSetRoleModal = ({ isOpen, onClose, onConfirm, users, roles, loading }) => {
  const [selectedRole, setSelectedRole] = useState('');
  const [roleDropdownOpen, setRoleDropdownOpen] = useState(false);
  const roleDropdownRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      setSelectedRole('');
      setRoleDropdownOpen(false);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (selectedRole) {
      onConfirm(selectedRole);
    }
  };

  return (
    <AdminModal
      isOpen={isOpen && users?.length > 0}
      onClose={onClose}
      title="Set User Roles"
      actions={(
        <>
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="admin-submit-button"
            onClick={handleConfirm}
            disabled={loading || !selectedRole}
          >
            {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Update All Roles'}
          </button>
        </>
      )}
    >
      <p>Set role for {users?.length} user{users?.length > 1 ? 's' : ''}:</p>
      <div className="admin-form-group">
        <label>New Role:</label>
        <CustomDropdown
          selected={selectedRole ? (roles[selectedRole]?.title || selectedRole) : 'Select Role'}
          options={
            Object.entries(roles)
              .map(([roleId, roleData]) => ({
                id: roleId,
                display: roleData.title || roleId,
                value: roleId,
              }))
              .sort((a, b) => a.display.localeCompare(b.display))
          }
          isOpen={roleDropdownOpen}
          toggleDropdown={() => setRoleDropdownOpen(!roleDropdownOpen)}
          onSelect={(option) => {
            setSelectedRole(option.value);
            setRoleDropdownOpen(false);
          }}
          className="admin-role-select"
          containerRef={roleDropdownRef}
          keyExtractor={(option) => option.id}
        />
      </div>
      <AdminBulkPreview
        items={users || []}
        getKey={(user) => user.userId}
        getName={(user) => user.name}
        getMeta={(user) => `${user.email} • Current role: ${user.role ? (roles[user.role]?.title || user.role) : 'Unknown'}`}
        noun="user"
      />
    </AdminModal>
  );
};

export default BulkSetRoleModal;
